import React from 'react';
import './App.css';
import HomePage from './pages/Components/HomePage';
import { Route, Routes } from 'react-router-dom';
import Signup from './auth/Signup';
import Login from './auth/Login';
import Cart from './pages/Components/Cart';
import Userdetail from './pages/Components/Userdetail';
import PaymentPage from './pages/Components/PaymentPage';


function App() {
  return (
    <div className="App">


      <Routes >
        <Route path='/' element={<HomePage />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/login' element={<Login />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/cart/order' element={<Userdetail />} />
        <Route path='/cart/order/pay' element={<PaymentPage />} />
      </Routes>

    </div>
  );
}

export default App;
